import * as types from '../mutations-types'
import Pusher from 'pusher-js'
import {API_URL} from '../../utils/endpoints'

const state = {
  pusherRef: null
}

const getters = {
  pusherRef: state => state.pusherRef
}

const actions = {
    setPusherRef({commit}) {
    const idToken = localStorage.getItem('idToken')
    const PUSHER_AUTH_URL = `${API_URL}/avl/broadcasting/auth?idToken=${idToken}`

    console.log('🔐 Configurando autenticación Pusher:', {
      url: PUSHER_AUTH_URL,
      hasToken: !!idToken,
      tokenLength: idToken ? idToken.length : 0
    })

    const pusherRef = new Pusher(process.env.API_KEY_PUSHER, {
      encrypted: true,
      cluster: 'mt1',
      authEndpoint: PUSHER_AUTH_URL,
      // Forzar el uso de WebSockets y deshabilitar fallbacks
      enabledTransports: ['ws', 'wss'],  // Solo WebSockets, no xhr
      disabledTransports: ['xhr_polling', 'xhr_streaming', 'sockjs'],  // Deshabilitar polling
      wsHost: 'ws-mt1.pusher.com',
      wsPort: 443,
      forceTLS: true,
      // Deshabilitar estadísticas que pueden causar requests adicionales
      enableStats: false,
      disableStats: true
    })

    // Log para verificar la conexión y configuración
    console.log('🔄 Inicializando Pusher con:', {
      key: process.env.API_KEY_PUSHER.substring(0, 6) + '...',
      cluster: 'mt1',
      wsHost: 'ws-mt1.pusher.com'
    })

    pusherRef.connection.bind('connecting', () => {
      console.log('🔄 Conectando a Pusher...')
    })

    pusherRef.connection.bind('connected', () => {
      const transport = pusherRef.connection.transport
      console.log('✅ Pusher conectado:', {
        transport: transport ? transport.name : 'unknown',
        socket_id: pusherRef.connection.socket_id
      })
    })

    pusherRef.connection.bind('error', error => {
      console.error('❌ Error de conexión Pusher:', {
        type: error.type,
        data: error.data
      })

      // Si el error es de autenticación, mostrar información adicional
      if (error.type === 'AuthError') {
        console.error('❌ Error de autenticación:', {
          mensaje: 'El servidor devolvió error 500 al autenticar',
          posiblesCausas: [
            'Token expirado o inválido',
            'Problema en el backend con el endpoint de autenticación',
            'Usuario no autorizado para canales presence'
          ]
        })
      }
    })

    return pusherRef
    // commit(types.SET_PUSHER_REF, pusherRef)
  }
}

const mutations = {
  [types.SET_PUSHER_REF](state, obj) {
    state.pusherRef = obj
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pusherStore.js